module.exports = __webpack_public_path__ + "static/media/webcamoff.f87f6879.svg";